import React from 'react';
import { Layout, Typography, Button, Card, Space } from 'antd';
import { TrophyOutlined, ExperimentOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../components/LanguageSwitcher';

const { Header, Content } = Layout;
const { Title, Paragraph } = Typography;

const Dashboard = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleLogout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('token_type');
    localStorage.removeItem('expires_in');
    localStorage.removeItem('userName');
    localStorage.removeItem('algoChainToken');
    localStorage.removeItem('.issued');
    localStorage.removeItem('.expires');
    navigate('/login');
  };

  const gotoWizard = () => {
    navigate('/wizard');
  };

  const gotoTest = () => {
    navigate('/test401');
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header style={{
        background: '#fff',
        padding: '0 24px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <Title level={3} style={{ margin: 0, color: '#1890ff' }}>{t('dashboard.appTitle')}</Title>
        <Space>
          <LanguageSwitcher />
          <Button onClick={handleLogout}>{t('common.logout')}</Button>
        </Space>
      </Header>
      <Content style={{ padding: '24px', background: '#f0f2f5' }}>
        <div style={{ maxWidth: 600, margin: '0 auto', textAlign: 'center' }}>
          <Card
            style={{
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              borderRadius: '12px',
              border: 'none'
            }}
            bodyStyle={{ padding: '48px 32px' }}
          >
            <Space direction="vertical" size="large" style={{ width: '100%' }}>
              <div>
                <TrophyOutlined style={{ fontSize: '48px', color: '#1890ff', marginBottom: '16px' }} />
                <Title level={2} style={{ margin: '0 0 16px 0', color: '#262626' }}>
                  {t('dashboard.investmentPreferences')}
                </Title>
              </div>

              <Paragraph style={{
                fontSize: '16px',
                color: '#595959',
                marginBottom: '32px',
                lineHeight: '1.6'
              }}>
                {t('dashboard.investmentDescription')}
              </Paragraph>

              <Button
                type="primary"
                size="large"
                // icon={<FormOutlined />}
                onClick={gotoWizard}
                style={{
                  height: '48px',
                  fontSize: '16px',
                  fontWeight: '500',
                  minWidth: '160px',
                  borderRadius: '8px'
                }}
              >
                {t('dashboard.start')}
              </Button>
            </Space>
          </Card>
        </div>
      </Content>
    </Layout>
  );
};

export default Dashboard;